import styled from "styled-components"

import tokens from "../_tokens"

const Table = styled.table`
  display: block;
  width: 100%;
  margin: 0 0 ${1.5 * tokens.size.base}px;
  overflow: auto;

  th {
    font-weight: 600;
  }

  th,
  td {
    padding: ${tokens.size.base}px ${1.5 * tokens.size.base}px;
    border: 1px solid ${tokens.color.border};
  }

  tr {
    background-color: ${tokens.color.white};
    border-top: 1px solid ${tokens.color.border};

    &:nth-child(2n) {
      background-color: ${tokens.color.bgLight};
    }
  }

  img {
    background-color: transparent;
  }
`

export default Table
